import { Dashboard } from "../../../shared/components/dashboard/dashboard";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
export function BackOfficeDashboard() {
  return (
    <ErrorBoundary>
      <Dashboard />
    </ErrorBoundary>
  );
}
